export default __webpack_public_path__ + "locales/es/Payments.json?hash=6a5713ccb80d7b5d5fed030f8d746dbb";